import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { LIVE_URL } from "../../../../config/config";
import useAuthToken from "../../../../hooks/useAuthToken";
ChartJS.register(ArcElement, Tooltip, Legend);

const NewMemberChart = () => {
  const { token, loading } = useAuthToken();

  const [memberData, setMemberData] = useState({
    total_users_man_woman: 0,
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(`${LIVE_URL}/admin/dashboard/get-counts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data && data.data) {
          setMemberData(data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (!loading) {
      fetchData();
    }
  }, [token, loading]);

  const data = {
    labels: [
      `Men: ${memberData.total_users_man_woman.men}`,
      `Women: ${memberData.total_users_man_woman.woman}`,
    ],
    datasets: [
      {
        data: [
          memberData.total_users_man_woman.men,
          memberData.total_users_man_woman.woman,
        ],
        backgroundColor: ["#01b1a9", "#e186e4"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "40%",
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div>
      <Pie data={data} options={options} />
    </div>
  );
};

export default NewMemberChart;
